module.exports = __webpack_public_path__ + "plugins/web/img/qrcode.677fc655.png";